import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box, Button, Grid } from "@mui/material";
import { adminLinks } from "../../variables/adminRoutes";
import { useMobile } from "common-frontend-components";
import { topPageId } from "../TopPage";
const Logo = ({ sx = {}, ...props }) => {
    return (_jsx(Box, { component: 'video', autoPlay: true, loop: true, muted: true, sx: sx, ...props, children: _jsx("source", { src: 'https://ramibarilan-photos-dev.s3.amazonaws.com/Rami+ELIPS+01.mp4', type: 'video/mp4' }, void 0) }, void 0));
};
export const HeaderLogo = () => {
    const isMobile = useMobile();
    const { logoSizeStyle, containerSizeStyle, offset, } = useMemo(() => {
        const ratio = 1382 / 977;
        const logoSize = isMobile ? 250 : 380;
        const containerSize = logoSize * 0.97;
        const getSizeStyle = (size) => ({ width: `${size}px`, height: `${size / ratio}px` });
        const logoSizeStyle = getSizeStyle(logoSize);
        const containerSizeStyle = getSizeStyle(containerSize);
        const offset = {
            bottom: (logoSize - containerSize) * 0.7 / 2,
            right: (logoSize - containerSize) * 1.5 / (2 * ratio),
        };
        return {
            logoSizeStyle,
            containerSizeStyle,
            offset,
        };
    }, [isMobile]);
    return (_jsx(Grid, { container: true, justifyContent: 'center', sx: { width: '100%', paddingBottom: 2 }, children: _jsx(Button, { onClick: adminLinks.posts, sx: { borderRadius: '50%' }, children: _jsx(Box, { sx: { overflow: 'hidden', borderRadius: '50%', ...containerSizeStyle }, children: _jsx("a", { href: '#' + topPageId, children: _jsx(Logo, { sx: { ...logoSizeStyle, position: 'relative', bottom: `${offset.bottom}px`, right: `${offset.right}px` } }, void 0) }, void 0) }, void 0) }, void 0) }, void 0));
    // return (
    //   <b>Ramibarilan</b>
    // )
};
//# sourceMappingURL=HeaderLogo.js.map